import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@mui/material';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import ContentForm from '../../../components/ui/Admin/Formations/ContentForm'

import APIS from "../../../utils/APIS"


const Formation = () => {
  const navigate = useNavigate()
  const params = useParams();

  const { contents, updateAdminContents } = useContext(SuperAdminContext)

  const [content, setContent] = useState(null)
  const [hasChanged, setHasChanged] = useState(false)

  const setActContent = () => {
    var findContent = contents?.find((l) => l.id.toString() == params?.id)

    if (findContent) {
      if (content == null || content.id !== findContent.id) {
        setContent(findContent)
      }
    } else {
      navigate("/admin/formation")
    }
  }

  useEffect(() => {
    if (params?.id && contents) {
      setActContent()
    }
  }, [contents, content, params])


  return (
    <>
      <Helmet>
        <title>Admin Modules | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/formation"
            title={'Info sur le module '+content?.name}
          >
            {content?.archived === "true" &&
              <Button
                variant="contained"
                sx={{ minHeight:"35px !important" }}
                disabled={hasChanged}
                onClick={() => {
                  APIS.archiveOrNotContent({id : content?.id, archived : "false"}).then((result) => {
                    updateAdminContents()
                    navigate('/admin/formation')
                  })
                }}
              >
                Désarchiver
              </Button>
            }
            {content?.archived === "false" &&
              <Button
                variant="contained"
                sx={{ minHeight:"35px !important" }}
                disabled={hasChanged}
                onClick={() => {
                  APIS.archiveOrNotContent({id : content?.id, archived : "true"}).then((result) => {
                    updateAdminContents()
                    navigate('/admin/formation')
                  })
                }}
              >
                Archiver
              </Button>
            }
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={content ? hasChanged : true}
              onClick={() => {
                navigate('/admin/formation/player/'+content?.id)
              }}
            >
              Player
            </Button>
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={!hasChanged}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Éditer le module
            </Button>
          </TopBar>


          {content !== null && (
            <ContentForm
              content={content}
              setHasChanged={setHasChanged}
            />
          )}

        </Box>
      </Box>
    </>
  )
};

export default Formation;
